
import { Inject, Options, Vue } from "vue-property-decorator";
import { AppInsights } from "@/trust-admin-app/appInsights";
import { TrustAPI } from "@/shared/modules/trust-api";
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import { EventEmitter } from "events";
import store from "@/trust-admin-app/store";
import ErrorIndicator from "@/shared/components/error-indicator/error-indicator";
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import { orderBy } from "lodash";
import { Category, SignatoryFilterRequest, SignatoryRequest, SignatoryView, PracticeView } from "@/shared/modules/typescript-trustapi-client/models";
import AddEditSignatoryModal from "./add-edit-signatory-modal/index.vue";
import { ref } from "vue";
import moment from "moment";
@Options({
  components: {
    LoadingIndicator,
    ErrorIndicator,
    AddEditSignatoryModal,
  },
  mixins: [FormatDateTimeMixin]
})
export default class PracticePeopleSignatories extends Vue {
  private ai = new AppInsights;

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private searchKeyword = '';
  private showActiveOnly = false;
  private showPCOnly = false;

  private sortMethod = 'desc';
  private activeSortHeader = 0;

  private signatories: SignatoryView[] = [];
  private signatoriesDisplay: any = [];
  private showAddEditModal = false;

  private signatoryRequest: SignatoryRequest = {};
  private categories: Category[] = [];

  private loadingContent = false;
  private errorLoadingContent = false;
  private loadingDataSet = false;
  private errorLoadingDataSet = false;

  private tableHeadings = [
    { text: 'LawID', value: 'lawId', sortable: true, sortMethod: 'desc' },
    { text: 'Name', value: 'name', sortable: true, sortMethod: 'acs' },
    { text: 'Category', value: 'categoryName', sortable: true, sortMethod: 'acs' },
    { text: 'Solely/ jointly', value: 'solelyJointly', sortable: true, sortMethod: 'acs' },
    { text: 'Commenced', value: 'commencedDate', sortable: true, sortMethod: 'asc' },
    { text: 'Terminated', value: 'terminatedDate', sortable: true, sortMethod: 'acs' },
    { text: '', value: '', sortable: false, sortMethod: 'acs' },
  ];

  created() {
    this.getGetCategories();
  }

  mounted() {
    this.loadTableData();
  }

  private getGetCategories() {
    this.apiService.CodeApi?.apiV2CodeGetCategoriesGet()
      .then(res => {
        this.categories = res.data.data;
      })
      .catch(err => {
        console.log('GetCategories error: ', err);
      })
  }

  private loadTableData(loadStat?: boolean) {
    this.loadingContent = true;

    const _body: SignatoryFilterRequest = {
      keyword: '',
      practiceId: this.selectedPractice.id,
      showActiveOnly: false,
      showPCOnly: false
    }

    this.apiService.PeopleApi?.apiV2PeopleGetSignatoriesPost(_body)
      .then(res => {
        this.signatories = res.data.data ?? [];
        this.signatoriesDisplay = this.signatories;
        for (let i = 0; i < this.signatories.length; i++) {
          this.signatoriesDisplay[i].name = this.signatories[i].firstName + ' ' + this.signatories[i].lastName;
          this.signatoriesDisplay[i].categoryName = this.signatories[i].category.name;
        }
        if (loadStat) this.$emit('loadStatData');
        this.sortTableColumn(1, true);
        this.loadingContent = false;
      })
      .catch(err => {
        this.eventCtrl.emit('show-snackbar', 'error', 'Unable to get signatory list: ' + err);
        this.ai.trackException('Error, Unable to get signatory list: ' + err);
        this.loadingContent = false;
        this.errorLoadingContent = true;
      })

  }

  private sortTableColumn(index: number, sortable: boolean) {
    if (sortable) {
      if (this.tableHeadings[index].sortable) {
        this.activeSortHeader = index;
        this.sortMethod = this.sortMethod === 'desc' ? 'asc' : 'desc';
        this.tableHeadings[index].sortMethod = this.sortMethod;
        if (this.signatories.length > 0) {
          const nameSorter = index == 1 ? (c: any) => c.name.toLowerCase() : [this.tableHeadings[index].value, (c: any) => c.name.toLowerCase()];
          const orderByResults = orderBy(
            this.signatories,
            nameSorter,
            [this.sortMethod as any]
          );
          this.signatoriesDisplay = orderByResults;
        }
      }
    }
  }

  private applyFilter(data: any) {
    if (this.searchKeyword == '') return data;
    const _result = data.filter((d: any) => {
      return (d.name.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) >= 0
        || d.lawId.toString().indexOf(this.searchKeyword.toLowerCase()) >= 0);
    })
    return _result;
  }

  private isActive(i: SignatoryView): boolean {
    const _terminatedDate = i.terminatedDate ?? null;
    if (_terminatedDate) {
      return moment().diff(i.terminatedDate, 'days') <= 0;
    } else {
      return true;
    }
  }

  private addNew() {
    this.signatoryRequest = {
      id: 0,
      practiceId: this.selectedPractice.id,
      signatoryTypeId: 1,
      solelyJointlyId: 0,
      lawId: '',
      firstName: '',
      lastName: '',
      categoryId: 0,
      commencedDate: ref(new Date()),
      terminatedDate: null,

    }
    this.showAddEditModal = true;
  }

  private edit(s: SignatoryView) {
    // Clone this object
    this.signatoryRequest = { ...s };
    this.signatoryRequest.signatoryTypeId = s.signatoryType.id;
    this.signatoryRequest.solelyJointlyId = s.solelyJointly.id;
    // Get status id
    // this.signatoryRequest.statusId = s.status['id'];
    // set the date format for date picker
    this.signatoryRequest.commencedDate = new Date(this.signatoryRequest.commencedDate);
    this.signatoryRequest.terminatedDate = this.signatoryRequest.terminatedDate !== null ? new Date(this.signatoryRequest.terminatedDate) : null;

    this.signatoryRequest.categoryId = s.category['id'];
    this.showAddEditModal = true;
  }

  get selectedPractice(): PracticeView {
    return store.getters.getSelectedPractice;
  }

}

